import * as shippingServices from '../services/shipping';
import { handleError } from '../utils/error';
import * as shippingConstants from '../Constants/shippingConstants';

export const shippingList = (filters, initialLoading) => async (dispatch) => {
  try {
    if (initialLoading) {
      dispatch({ type: shippingConstants.SHIPPINGLIST_FETCH_START });
    }

    shippingServices.filterParams(filters);

    const { results, count } = await shippingServices.fetchShippings(filters);

    dispatch({
      type: shippingConstants.SHIPPINGLIST_FETCH_SUCCESS,
      payload: { results, count },
    });
  } catch (err) {
    dispatch({
      type: shippingConstants.SHIPPINGLIST_FETCH_ERROR,
      payload: handleError(err),
    });
  }
};

export const addToShipping = (id, qty) => async (dispatch, getState) => {
  try {
    dispatch({ type: shippingConstants.SHIPPING_FETCH_START });

    const data = await shippingServices.fetchShipping(id);

    dispatch({
      type: shippingConstants.SHIPPING_FETCH_SUCCESS,
      payload: payLoadForShippingItem(data, qty),
    });

    localStorage.setItem('cartAreas', JSON.stringify(getState().cart.cartAreas));
  } catch (err) {
    dispatch({
      type: shippingConstants.SHIPPING_FETCH_FAIL,
      payload: handleError(err),
    });
  }
};

export const shippingListForAdmin = (initialLoading) => async (dispatch) => {
  try {
    if (initialLoading) {
      dispatch({ type: shippingConstants.SHIPPINGLIST_FETCH_START });
    }

    const { results, count } = await shippingServices.fetchShippings({});

    dispatch({
      type: shippingConstants.SHIPPINGLIST_FETCH_SUCCESS,
      payload: { results, count },
    });
  } catch (err) {
    dispatch({
      type: shippingConstants.SHIPPINGLIST_FETCH_ERROR,
      payload: handleError(err),
    });
  }
};

export const shipping = (id) => async (dispatch) => {
  try {
    dispatch({ type: shippingConstants.SHIPPING_FETCH_START });

    const data = await shippingServices.fetchShipping(id);

    dispatch({
      type: shippingConstants.SHIPPING_FETCH_SUCCESS,
      payload: data,
    });
  } catch (err) {
    dispatch({
      type: shippingConstants.SHIPPING_FETCH_FAIL,
      payload: handleError(err),
    });
  }
};


export const deleteShipping = (id) => async (dispatch) => {
  try {
    dispatch({ type: shippingConstants.DELETE_SHIPPING_START });

    await shippingServices.deleteShipping(id);

    dispatch({
      type: shippingConstants.DELETE_SHIPPING_SUCCESS,
    });
  } catch (err) {
    dispatch({
      type: shippingConstants.DELETE_SHIPPING_FAIL,
      payload: handleError(err),
    });
  }
};

export const createShipping = (formData) => async (dispatch) => {
  try {
    dispatch({ type: shippingConstants.CREATE_SHIPPING_START });

    await shippingServices.createShipping(formData);

    dispatch({
      type: shippingConstants.CREATE_SHIPPING_SUCCESS,
    });
  } catch (err) {
    dispatch({
      type: shippingConstants.CREATE_SHIPPING_FAIL,
      payload: handleError(err),
    });
  }
};

export const EditShipping = (id, UpdatedData) => async (dispatch) => {
  try {
    dispatch({ type: shippingConstants.EDIT_SHIPPING_START });

    await shippingServices.updateShipping(id, UpdatedData);

    dispatch({
      type: shippingConstants.EDIT_SHIPPING_SUCCESS,
    });
  } catch (err) {
    dispatch({
      type: shippingConstants.EDIT_SHIPPING_FAIL,
      payload: handleError(err),
    });
  }
};

export const payLoadForShippingItem = (data, qty) => {
  return {
    shippingId: data._id,
    shippingPrice: data.shippingPrice,
    area: data.area,
    qty,
  };
};
